import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  id: "archive",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.903 28",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Tracé_21",
      "data-name": "Tracé 21",
      d: "M24.708,8H3.2A1.2,1.2,0,0,0,2,9.2V25.927a1.2,1.2,0,0,0,1.2,1.2H24.708a1.2,1.2,0,0,0,1.2-1.2V9.2A1.2,1.2,0,0,0,24.708,8Zm-4.781,8.366a1.2,1.2,0,0,1-1.2,1.2H9.171a1.2,1.2,0,0,1-1.2-1.2V12.781h2.39v2.39h7.171v-2.39h2.39Z",
      transform: "translate(-2 0.877)"
    }, null, -1),
    _createElementVNode("rect", {
      id: "Rectangle_12",
      "data-name": "Rectangle 12",
      width: "20.487",
      height: "3.415",
      transform: "translate(1.708 3.415)"
    }, null, -1),
    _createElementVNode("rect", {
      id: "Rectangle_13",
      "data-name": "Rectangle 13",
      width: "13.658",
      height: "1.707",
      transform: "translate(5.123 0)"
    }, null, -1)
  ])))
}